// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionRulesMaybe_root__1Pmp9","title":"SectionRulesMaybe_title__2hw6U","rules":"SectionRulesMaybe_rules__23npv"};